import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/lib/useLanguage";
import { servicePages } from "@/lib/servicePages";

export default function ServicePageLinks({ footer = false }: { footer?: boolean }) {
  const { language } = useLanguage();
  return (
    <ul className={footer ? "space-y-2" : "mt-8 grid gap-4 md:grid-cols-3"}>
      {servicePages.map((page) => (
        <li key={page.path}>
          <Link to={page.path} className={footer
            ? "hover:underline transition-colors"
            : "flex items-start justify-between gap-3 border-t border-border pt-4 text-primary font-semibold hover:underline"}>
            <span className="min-w-0 break-words">{page.copy[language].title.split(" | ")[0]}</span>
            {!footer && <ArrowUpRight className="mt-1 h-4 w-4 shrink-0" aria-hidden="true" />}
          </Link>
        </li>
      ))}
    </ul>
  );
}